<template>
  <adminTable
    :hideSeachButton="true"
    :tableLoading="tableLoading"
    :totalList="totalList"
    v-model:page="page"
    v-model:limit="limit"
    v-model:searchForm="searchForm"
    :tableData="tableData"
    @search="getList"
  >
    <template v-slot:query-button-right>
      <el-button
        type="primary"
        icon="CirclePlus"
        @click="editItem('add', {})"
        v-permission
        >添加</el-button
      >
    </template>
    <template v-slot:table>
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="title" label="等级名称" width="150" />
      <el-table-column prop="extra" label="收益加成(%)" width="120" />
      <el-table-column prop="team_invest" label="团队投资要求" width="150" />
      <el-table-column prop="lv1_invite" label="一级返利(%)" width="120" />
      <el-table-column prop="lv2_invite" label="二级返利(%)" width="120" />
      <el-table-column prop="lv1_buy" label="一级认购奖励(%)" width="140" />
      <el-table-column prop="lv2_buy" label="二级认购奖励(%)" width="140" />
      <el-table-column prop="create_at" label="创建时间" width="180" />
      <el-table-column prop="update_at" label="更新时间" width="180" />
      <el-table-column
        label="操作"
        fixed="right"
        width="200"
        v-if="currentUser.role == 0"
      >
        <template #default="scope">
          <el-button
            type="primary"
            icon="Edit"
            v-permission
            @click="editItem('edit', scope.row)"
            >编辑</el-button
          >
          <el-button
            type="danger"
            icon="Delete"
            v-permission
            @click="deleteAction(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </template>
    <el-dialog v-model="dialogFlag" title="编辑/新增" width="900">
      <editPop :key="editRow" ref="editFormRef" :item="editRow" />

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogFlag = false">关闭</el-button>
          <el-button type="primary" @click="submitForm"> 保存 </el-button>
        </div>
      </template>
    </el-dialog>
  </adminTable>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted } from "vue";
import editPop from "./components/energyLevel/editPop.vue";
import { ElMessage, ElMessageBox } from "element-plus";

const dialogFlag = ref(false);
const editFormRef = ref(false);
const searchForm = ref({});
const editRow = ref({});
const formType = ref("add");

onMounted(() => {
  getList();
});

const currentUser = JSON.parse(sessionStorage.getItem("currentUser") || "null");
const { proxy } = getCurrentInstance();

const page = ref(1);
const limit = ref(10);
const totalList = ref(0);
const tableLoading = ref(false);
const tableData = ref([]);
const getList = async () => {
  tableLoading.value = true;
  const res = await proxy.$http({
    type: "get",
    url: "/LevelEnergy/getLevelLists",
    params: {
      page: page.value,
      limit: limit.value,
    },
  });
  tableLoading.value = false;
  if (res.code == 0) {
    tableData.value = res.data.data;
    totalList.value = res.data.total;
  }
};

const editItem = (type, row) => {
  formType.value = type;
  editRow.value = row;
  dialogFlag.value = true;
};

const deleteAction = (row) => {
  ElMessageBox.confirm("是否删除?", "Warning", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(async () => {
      const res = await proxy.$http({
        method: "post",
        url: "/LevelEnergy/deleteLevel",
        data: { id: row.id },
      });
      if (res.code == 0) {
        getList();
      }
      ElMessage({
        type: "success",
        message: res.msg,
      });
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消删除",
      });
    });
};

const submitForm = async () => {
  const url = formType.value == "add" ? "/LevelEnergy/addLevel" : "/LevelEnergy/updateLevel";
  const data = editFormRef.value.form;
  if (formType.value == "add") {
    data.id = null;
  }
  const res = await proxy.$http({
    method: "post",
    url: url,
    data: data,
  });

  if (res.code == 0) {
    dialogFlag.value = false;
    getList();
    ElMessage({
      type: "success",
      message: res.msg,
    });
  } else {
    ElMessage({
      type: "error",
      message: res.msg,
    });
  }
};
</script>

<style lang="less" scoped></style>

